import {Dispatch, SetStateAction, useCallback, useEffect, useState} from 'react';
import {Test} from '../service/types';

export function useTestSelection(tests: Test[]): {
	selectedTests: number[],
	select: (testID: number) => void,
	toggleAll: VoidFunction,
	setSelectedTests: Dispatch<SetStateAction<number[]>>
} {
	const [selectedTests, setSelectedTests] = useState<number[]>([]);

	const select = useCallback((test: number) => {
		setSelectedTests((values) => {
			if(values.includes(test)) {
				return values.filter(s => s !== test);
			} else {
				return [...values, test];
			}
		});
	}, []);

	const toggleAll = useCallback(() => {
		setSelectedTests((values ) => {
			const allTestsIDs = tests.map(s => s.id);
			const allSelected = allTestsIDs?.every(s => values?.includes(s));

			if(allSelected) {
				return [];
			} else {
				return [...allTestsIDs];
			}
		});
	}, [tests]);

	useEffect(() => {
		setSelectedTests((value) => value.filter(s => tests.map(s => s.id).includes(s)));
	}, [tests]);
	
	return {
		selectedTests,
		setSelectedTests,
		select,
		toggleAll,
	};
}